"use client";

import type { RoomTypeRoomDetailPayload } from "../../room-detail/room-detail-drawer-provider";
import type { RoomTypeReserveContextValue } from "../_context/room-type-reserve-context";

import { RoomTypeReserveInlineContent } from "./room-type-reserve-inline-content";

/**
 * 部屋タイプ予約経路で `useRoomDetailDrawer().open()` に渡す payload を組み立てる。
 * room-detail は予約の実装詳細を知らないため、reserve 側の部品を `inlineContent` に注入する。
 */
export function buildRoomDetailPayloadForReserve(
  roomTypeId: string,
  ctx: RoomTypeReserveContextValue,
): RoomTypeRoomDetailPayload {
  return {
    roomTypeId,
    reservation: {
      inlineContent: {
        render: ({ closeAll }) => (
          <RoomTypeReserveInlineContent
            roomTypeId={roomTypeId}
            ctx={ctx}
            closeAll={closeAll}
          />
        ),
      },
    },
  };
}
